"use strict";

exports.__esModule = true;
exports.UtilizationAggregatedChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _RestAPI = require("../../API/RestAPI");
var _Spinner = require("../../Core/Spinner");
var _SelectedDevicesController = require("../../Device/SelectedDevicesController");
var _TimeContext = require("../../Time/TimeContext");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _AggregateMetricChartController = require("../common/AggregateMetricCharts/AggregateMetricChartController");
var _getTickXFormatter = require("../common/AggregateMetricCharts/getTickXFormatter");
var _ScrollableChart = require("../common/AggregateMetricCharts/ScrollableChart");
var _getMetricQuery = require("../common/getMetricQuery");
var _LegendSidebar = require("./LegendSidebar");
var _stateDetails = require("./stateDetails");
var _UtilizationChartDataFormatter = require("./UtilizationChartDataFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ErrorText = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationAggregatedChart__ErrorText",
  componentId: "sc-1qmjz6i-0"
})(["display:flex;justify-content:center;align-items:center;width:", "px;height:", "px;font-size:17px;font-weight:500;"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var UtilizationAggregatedChart = exports.UtilizationAggregatedChart = function UtilizationAggregatedChart(props) {
  var _React$useContext = _react["default"].useContext(_RestAPI.RestAPIContext),
    plantName = _React$useContext.plantName;
  var _React$useContext2 = _react["default"].useContext(_TimeContext.TimeContext),
    timezone = _React$useContext2.timezone;
  var device = (0, _SelectedDevicesController.useSelectedDevices)();
  var timePeriod = (0, _TimePeriodController.useSelectionContext)();
  var width = props.width,
    height = props.height,
    selectedStates = props.selectedStates,
    setSelectedStates = props.setSelectedStates,
    tooltipSort = props.tooltipSort;
  var timeAggregation = (0, _timeAggregationBinMapping.getTimeGroupingFromAgg)({
    aggregations: props.aggregations
  });
  var timeAggregationName = (0, _timeAggregationBinMapping.getTimeGroupingNameFromAgg)({
    aggregations: props.aggregations
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "UtilizationAggregatedChart",
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement(_AggregateMetricChartController.AggregateMetricChartController, {
    query: (0, _getMetricQuery.getMetricQuery)({
      plant: plantName,
      interval: timePeriod.interval,
      device: device,
      windowType: timeAggregationName,
      timezoneName: timezone.name,
      metrics: ["duration_sum"],
      bins: ["states", "device"]
    })
  }, function (_ref) {
    var data = _ref.data,
      fetching = _ref.fetching;
    if (fetching) {
      return /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null);
    }
    if (data.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(ErrorText, {
        width: width,
        height: height
      }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Widgets.NoData.Warning",
        defaultMessage: "No Data Available"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(_UtilizationChartDataFormatter.UtilizationChartDataFormatter, {
      data: data,
      selectedStates: selectedStates,
      timeAggregationName: timeAggregationName,
      devices: device,
      tooltipSort: tooltipSort
    }, function (_ref2) {
      var series = _ref2.series,
        totalMinorBar = _ref2.totalMinorBar;
      var tickXFormatter = function tickXFormatter(tickXFormatterProps) {
        return (0, _getTickXFormatter.getXTickFormatter)(Object.assign({
          windowType: timeAggregationName
        }, tickXFormatterProps));
      };
      return /*#__PURE__*/_react["default"].createElement(_ScrollableChart.ScrollableChart, _extends({}, props, {
        width: width,
        height: height,
        minorBarPerMajorBar: totalMinorBar,
        minorBarSize: 50,
        series: series,
        hideYUnits: true,
        xAxisLabel: timeAggregation && timeAggregation.label,
        legends: function legends(props) {
          return /*#__PURE__*/_react["default"].createElement(_LegendSidebar.LegendSidebar, _extends({}, props, {
            selectedStates: selectedStates,
            setSelectedStates: setSelectedStates,
            states: (0, _UtilizationChartDataFormatter.sortLegendStates)(_stateDetails.stateDetails, data, tooltipSort)
          }));
        },
        tickXFormat: tickXFormatter,
        builtInTooltip: false
      }));
    });
  }));
};